import * as d3 from 'd3'

export default {


  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))


      this.layout = json.layout
      console.log(this.rawData)
    },

    

  }
}